module.exports = __webpack_public_path__ + "static/media/Lacapital-Studio-Option-1-.4441174f.webp";